// ---Dependencies
import React, { useEffect, useState } from 'react';
import { navigate } from '@reach/router';
// ---Redux
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken } from '../../clearances/utils/localStorageService';
import { fetchUserPermissions, logout } from '../../clearances/store/auth';

/**
 * SecuredApp Component: Thinked on monitor the credentials of the user in
 * the full app with excepcion of the login, validates the credentials of the user
 * in the redux "authReducer" and redirects the user to the "login" page if the user
 * doesn't have credentials
 * @param {props.App} App - The full react app wrapped in a single component
 * @returns {ReactElement}
 */
export function SecuredApp({ App }) {
    // ------------------------- CONST, HOOKS && STATES
    const { auth } = useSelector((s) => s);
    const token = getAuthToken();
    const [isAuth, setIsAuth] = useState(!!token);
    const dispatch = useDispatch();
    // eslint-disable-next-line
    useEffect(() => checkCredentials(), []);
    // eslint-disable-next-line
    useEffect(() => giveAccess(), [token]);

    // ------------------------- MAIN METHODS
    function checkCredentials() {
        if (token?.length) dispatch(fetchUserPermissions(token));
    }
    function giveAccess() {
        if (token) {
            setIsAuth(true);
        } else if (!token) {
            dispatch(logout());
            setIsAuth(false);
            navigate('/login');
        }
    }
    // ------------------------- RENDER
    if (isAuth) {
        return <App />;
    }
    return <h1>Redirecting...</h1>;
}
